var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", { staticClass: "table table-striped" }, [
      _c(
        "tbody",
        _vm._l(_vm.rowHeaders, function (rowHeader, header_index) {
          return _c(
            "tr",
            { key: rowHeader.name },
            [
              _c("td", { class: rowHeader.classes }, [
                _vm._v(_vm._s(rowHeader.name)),
              ]),
              _vm._l(_vm.prepareData, function (column, column_index) {
                return _c(
                  "td",
                  {
                    key: "col_data_" + column_index,
                    class: column.cellByIndex(header_index).classes,
                  },
                  [
                    _vm._t(
                      "cell",
                      function () {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(column.cellByIndex(header_index).value)
                            ),
                          ]),
                        ]
                      },
                      { cell: column.cellByIndex(header_index) }
                    ),
                  ],
                  2
                )
              }),
            ],
            2
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }